import { useEffect, useState } from 'react';

const WINDOW_SM = 767;

export const useDevice = () => {
  const [isPc, setIsPc] = useState(false);
  const [chromeEdg, setChromeEdg] = useState(false);

  useEffect(() => {
    setChromeEdg(navigator.userAgent.includes('Chrome') || navigator.userAgent.includes('Edg'));

    const handleResize = () => {
      setIsPc(window.innerWidth > WINDOW_SM);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isPc,
    chromeEdg,
  };
};
